export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const BASE_URL = process.env.REACT_APP_BASE_URL;
